import { isNil, isEmpty, size, isFunction } from 'lodash';

// define a mixin object
export default {

  data() {
    return {
    };
  },


  updated: function () {
  },

  computed: {
    dayMonthFormat: function () {
      return this.$moment.localeData().longDateFormat('L').replace(/(.?)[yY]{1,6}(.?)/gm, '$1$2');
    },
    dayMonthMask: function () {
      return isEmpty(this.dayMonthFormat) ? '##.##.' : this.dayMonthFormat.replace(/[dDmM]/g, '#');
    },
    $systemLanguages: function () {
      return [
        'de',
        'en',
        'es',
        'el',
        'fr',
        'it',
        'tr',
      ];
    },
    $locale: function () {
      return this.$store.getters['layout/locale'] || 'de';
    },
    $shortLocale: function () {
      return this.$locale.substring(0, 2).toLowerCase();
    },
  },

  created: function () {
    let lang = localStorage.getItem('locale');

    if (isEmpty(lang)) {
      lang = (navigator.language || navigator.userLanguage || 'de').substring(0, 5);
    }

    if (lang.length >= 2) {
      this.setLocale(lang);
    }
  },

  methods: {
    setLocale(locale) {
      if (locale !== window.i18n.locale || locale !== this.$locale) {
        this.$store.commit('layout/locale', locale);
        this.$i18n.locale = locale;
        localStorage.setItem('locale', locale);
        this.$moment.locale(locale);
        window.i18n.locale = locale;
        document.querySelector('html').setAttribute('lang', locale);
        try { this.$rollbar.configure({ payload: { locale: locale } }); } catch (ignore) { /* ignore */ }
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/LocaleMixin.js